import { initializeApp } from "firebase/app";
import { getMessaging, getToken, isSupported, Messaging } from "firebase/messaging";
import { postToEndpointWithToken } from "./AxiosHelper";

export let messaging: Messaging;

//make sure to call it only once in the app
export const initializeFirebase = () => {
    const firebaseConfig = {
        apiKey: "AIzaSyCTQF9tXnyP-mMIHnN5kBWmZWm3gLuF07s",
        authDomain: "rd-sam.firebaseapp.com",
        projectId: "rd-sam",
        storageBucket: "rd-sam.firebasestorage.app",
        messagingSenderId: "129439421434",
        appId: "1:129439421434:web:c30e260f89fdefdbe9ca43"
    };

    isSupported().then(supported => {
        if (supported) {
            const app = initializeApp(firebaseConfig);
            messaging = getMessaging(app);
        } else {
            console.warn("Firebase is not supported on this device. Notifications will not work.")
        }
    });
}
const FCM_TOKEN_LOCAL_STORAGE_KEY = 'FCMToken';

export const refreshFCMToken = (token: string) => {
    if (typeof Notification === 'undefined') {
        console.warn('This browser does not support notifications.');
        return;
    }

    Notification.requestPermission().then(permission => {
        if (permission !== 'granted') {
            console.error('FCM notification permission was not granted by the user. Received: ' + permission);
        } else {
            getToken(messaging, {
                vapidKey: 'BF4CT2kwIBvXhD-HEzxezovme23yLJHnwU7J9II_PzOuX6ObB_-qbOoGSGW7onDzsEgI5v2-n3HcrW-A5lmu6fI',
            })
                .then((fcmToken) => {
                    if (fcmToken) {
                        postToEndpointWithToken('registerFCMToken', token, { FCMToken: fcmToken })
                            .then(() => localStorage.setItem(FCM_TOKEN_LOCAL_STORAGE_KEY, fcmToken))
                            .catch((error) => {
                                //these are not critical errors, we can live withouth notifications
                                console.warn('Error refreshing FCM token in server:', error);
                            })
                    } else {
                        console.warn('No registration token available. Request permission to generate one.');
                    }
                })
                .catch((error) => {
                    //these are not critical errors, we can live withouth notifications
                    console.warn('Error getting FCM token from firebase:', error);
                });
        }
    })
}

export const getFCMToken = (): string | null => {
    return localStorage.getItem(FCM_TOKEN_LOCAL_STORAGE_KEY);
}

export const clearFCMToken = () => {
    localStorage.removeItem(FCM_TOKEN_LOCAL_STORAGE_KEY);
}
